import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientLogo, DEFAULT_CLIENT_LOGOS } from '../../data/default-client-logos';

@Component({
  selector: 'app-client-logo-strip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './client-logo-strip.component.html',
  styleUrl: './client-logo-strip.component.scss',
})
export class ClientLogoStripComponent {
  /** When null or empty, {@link DEFAULT_CLIENT_LOGOS} is used. */
  @Input() logos: ClientLogo[] | null = null;

  /** Optional label above the logos (not rendered when empty). */
  @Input() title = '';

  /** `wrap` — flex row; `marquee` — infinite horizontal scroll (duplicated row). */
  @Input() variant: 'wrap' | 'marquee' = 'wrap';

  /**
   * `hero` — tighter strip under homepage hero.
   * `section` — standalone proof block (e.g. operator page): slightly larger marks.
   */
  @Input() wrapPreset: 'hero' | 'section' = 'hero';

  get resolvedLogos(): ClientLogo[] {
    return this.logos?.length ? this.logos : DEFAULT_CLIENT_LOGOS;
  }
}
